<template>
  <v-container fluid>
    <div v-if="activeTerminal !== ''">
      <Title :title="'Splashscreen Library - ' + activeTerminal" />
      <v-row align="center" justify="center">
        <v-col cols="11">
          <v-list dense>
            <v-list-item v-if="splashscreens.length == 0">
              <v-list-item-content>
                <v-list-item-title align="center">No data</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link v-else>
              <v-list-item-action>
                <v-btn icon>
                  <v-icon>{{ "remove_red_eye" }}</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ splashscreens[0].name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action @click="removeSplashscreen(splashscreens[0]._id)">
                <v-btn icon>
                  <v-icon>{{ "delete" }}</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="11" v-if="splashscreens.length == 0">
          <v-subheader class="pl-0">Add new splashscreen below</v-subheader>
          <v-form ref="form" @submit.prevent="addSplashScreen">
            <v-row align="start">
              <v-col cols="10">
                <v-file-input
                  accept="video/mp4"
                  width="100%"
                  height="40"
                  outlined
                  dense
                  show-size
                  label="File input"
                  :error-messages="error"
                ></v-file-input>
              </v-col>
              <v-col cols="2">
                <v-btn type="submit" width="100%" height="40" color="primary" :loading="isLoading">
                  <v-icon>{{ "add" }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <Title :title="'Please choose terminal you need in AppBar List'" />
    </div>
  </v-container>
</template>

<script>
import Title from "../components/Title.vue";

import {mapState} from "vuex";

export default {
  name: "SplashScreen",
  data: () => ({
    splashscreens: [],
    error: "",
    isLoading: false
  }),
  components: {
    Title,
  },
  computed: {
    ...mapState('terminals', ["activeTerminal"]),
  },
  watch: {
    activeTerminal() {
      if (this.activeTerminal !== "") {
        this.receiveSplashscreens();
      }
    },
  },
  methods: {
    receiveSplashscreens() {
      this.$http.get("rest/splashscreen/" + this.activeTerminal).then((res) => {
        this.splashscreens = [res.data];
      })
      .catch(() => {
        this.splashscreens = []
      });
    },
    addSplashScreen(e) {
      this.isLoading = true
      var file = e.target[2].files[0];
      var formData = new FormData();

      formData.set("terminal", this.activeTerminal);
      formData.append("animation", file);

      this.$http.post("rest/splashscreen/", formData)
        .then(() => {
          this.receiveSplashscreens();
          this.$refs.form.reset()
        })
        .finally(() => {
          this.isLoading = false
        })

    },
    removeSplashscreen(id) {
      this.$http.delete('/rest/splashscreen/' + id)
        .then(() => {
          this.receiveSplashscreens();
        })
    }
  },
  mounted() {
    if (this.activeTerminal !== "") {
      this.receiveSplashscreens();
    }
  },
};
</script>